// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sh-c";
export var backButton = "_sh-4";
export var backIcon = "_sh-5";
export var chevronShortcut = "_sh-6";
export var container = "_sh-1";
export var editor = "_sh-8";
export var editorWrapper = "_sh-7";
export var prefix = "_sh-2";
export var searchIcon = "_sh-3";
export var suffix = "_sh-9";
export var suffixContent = "_sh-a";
export var suffixText = "_sh-b";
export var wrapper = "_sh-0";